var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9202 3.01322C15.5204 2.60554 15.0456 2.28215 14.5231 2.0615C14.0006 1.84086 13.4406 1.72729 12.875 1.72729C12.3094 1.72729 11.7494 1.84086 11.2268 2.0615C10.7043 2.28215 10.2296 2.60554 9.82977 3.01322L8.99997 3.85889L8.17017 3.01322C7.36252 2.19013 6.26713 1.72772 5.12495 1.72772C3.98277 1.72772 2.88737 2.19013 2.07973 3.01322C1.27209 3.83631 0.818359 4.95266 0.818359 6.11668C0.818359 7.28071 1.27209 8.39706 2.07973 9.22015L2.90953 10.0658L8.99997 16.2728L15.0904 10.0658L15.9202 9.22015C16.3202 8.81266 16.6376 8.32885 16.8541 7.79635C17.0706 7.26385 17.182 6.69309 17.182 6.11668C17.182 5.54028 17.0706 4.96952 16.8541 4.43702C16.6376 3.90452 16.3202 3.4207 15.9202 3.01322Z",
    stroke: "#2BAE66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.6501ca693a0e0b594117d3fa52784d11.svg";
export { ForwardRef as ReactComponent };